import { lazy } from 'react';

export { Tariff } from './tariff';

export const LazyTariffDetails = lazy(() => import('./tariff-details').then((mod) => ({ default: mod.TariffDetails })));
